<div *transloco="let t" class="col grid-item">
  <div [class.zoom-wrapper]="zoomEffect" [class.finished]="isFinishedLeague">
    <div class="event-card position-relative" [class.zoom-target]="zoomEffect">
      <div class="image-wrapper">
        <div class="finished-event-ribbon d-flex justify-content-end align-items-center">
          <div class="tag-wrapper">
            @if (isFinishedLeague) {
              <span class="fw-medium text-uppercase">
              {{ t('league.item.status.2') }}
            </span>
            } @else {
              <span class="fw-medium text-uppercase">
                {{ league | leagueNextRound | uppercase }}
              </span>
            }
          </div>
        </div>
        <div class="position-relative">
          @if (league?.imageMedium !== null) {
            <img src="{{league!.imageMedium}}" alt="" class="bck-img" appImageFallback>
          }
          @if (league?.imageMedium === null) {
            <img src="{{environment.assetsImagesPath + '/assets/img/hiker.png'}}" alt="" class="bck-img"
                 appImageFallback>
          }
          <div class="img-overlay"></div>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="title-wrapper">
          <h5 class="title-wrapper__title mb-0 trim-text-second-line">
            <app-language-output [hrLabel]="league?.name" [enLabel]="league?.nameEng" [bsLabel]="league?.nameBs"
                                 [itLabel]="league?.nameIta" [siLabel]="league?.nameSlo" [srLabel]="league?.nameSr"
                                 [defaultLanguage]="league?.defaultLanguage" [languages]="languages"/>
          </h5>
        </div>
      </div>
      <div class="pb-2">
        <ul class="square-list square-list--inline">
          <li class="text-uppercase fw-semibold">
            <small>{{ league?.sportId ? t('app.common.sports.' + league!.sportId) : "" }}</small>
          </li>
          <li class="text-uppercase">
            @if (league?.start && league?.end) {
              <div>
                <small>{{ league!.start | date:'MMM yyyy' }} - {{ league!.end | date:'MMM yyyy' }}</small>
              </div>
            }
          </li>
        </ul>
      </div>
      <div class="event-card__event-info d-flex align-items-stretch">
        <div class="race-length-wrapper d-flex align-items-center flex-grow-1">
          <div class="d-flex align-items-center pe-3">
            <span>{{ t('league.total.events') }}</span>
            <div class="v-separator"></div>
            <span>{{ league?.events?.length ?? 0 }}</span>
          </div>
          <div class="d-flex align-items-center ps-3">
            <span>{{ t('league.events.to.go') }}</span>
            <div class="v-separator"></div>
            <span>{{ league | leagueEventsToGo }}</span>
          </div>
        </div>
        @if (!isFinishedLeague) {
          <div class="event-card__race-it-wrapper d-flex align-items-center justify-content-center">
            <app-rounded-button [label]="t('event.race.it')"/>
          </div>
        }
      </div>
      @if (isFinishedLeague) {
        <div class="event-card__race-it-wrapper d-flex align-items-center justify-content-center">
          <app-rounded-button [label]="t('event.race.it')" [isDisabled]="true"/>
        </div>
      }
    </div>
  </div>
</div>
